import { MultiSelect } from "@progress/kendo-react-dropdowns";
import MultiSelectItemWithCheckbox from "./MultiSelectItemWithCheckbox";
import { useComponentProperties } from "../../../../Hooks/Display/useComponentProperties";
import { cloneElement, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

function WorkWeekMultiSelect({ disabled }) {

    const { t, ready: tReady } = useTranslation("display/components/calendar");

    const [Weeks, setWeeks] = useState([
        {
            "text": "Sunday",
            "value": "Sunday"
        },
        {
            "text": "Monday",
            "value": "Monday"
        },
        {
            "text": "Tuesday",
            "value": "Tuesday"
        },
        {
            "text": "Wednesday",
            "value": "Wednesday"
        },
        {
            "text": "Thursday",
            "value": "Thursday"
        },
        {
            "text": "Friday",
            "value": "Friday"
        },
        {
            "text": "Saturday",
            "value": "Saturday"
        }
    ]);

    const [properties, setProperties] = useComponentProperties();
    const ref = useRef(null);
    const [opened, setOpened] = useState(false);
    const [value, setValue] = useState(properties.workWeek || []);
    
    useEffect(() => {
        if (tReady) {
            const weeks = [
                {
                    "text": t("days.sunday"),
                    "value": "Sunday"
                },
                {
                    "text": t("days.monday"),
                    "value": "Monday"
                },
                {
                    "text": t("days.tuesday"),
                    "value": "Tuesday"
                },
                {
                    "text": t("days.wednesday"),
                    "value": "Wednesday"
                },
                {
                    "text": t("days.thursday"),
                    "value": "Thursday"
                },
                {
                    "text": t("days.friday"),
                    "value": "Friday"
                },
                {
                    "text": t("days.saturday"),
                    "value": "Saturday"
                }
            ];
            setWeeks(weeks);
        }
    }, [tReady])

    useEffect(() => {
        const workWeek = properties.workWeek || [];
        const selectedValues = workWeek.map(day => {
            return Weeks.find(week => week.value === day);
        });
        setValue(selectedValues);
    }, [Weeks, properties.workWeek])

    function handleInputChange(event) {
        const newValue = event.target.value.map(day => day.value);
        setProperties(event.target.name, newValue);
    }

    function toggleOpenMultiSelect() {
        setOpened(!opened);
    }

    return (
        <div>
            <MultiSelect
                ref={ms => ref.current = ms}
                disabled={disabled}
                name="workWeek"
                className="form-control-custom work-week-multi-select"
                autoClose={false}
                itemRender={MultiSelectItemWithCheckbox}
                tags={[{ text: `${value.length} selected`, data: value }]}
                tagRender={(tagData, li) => {
                    return cloneElement(
                        li,
                        {
                            ...li.props,
                            onClick: ref.current?.base?.togglePopup
                        }
                    )
                }}
                data={Weeks}
                value={value}
                onChange={handleInputChange}
                textField="text"
                dataItemKey="value"
            />
            <button className="bg-white border-0" type="button" onClick={toggleOpenMultiSelect} disabled={disabled}>
                <i className="fas fa-pencil text-primary" />
            </button>
        </div>
    )
}

export default WorkWeekMultiSelect;